import React from 'react'
import { Process } from './Process/Process'
import { getAncestorProcesses } from '../utils/process'
import c from './IOPanel.module.css'

export const IOPanel = ({
  rtTaskId,
  output,
  dtProcesses,
  dtSockets,
  rtProcesses,
  rtSockets,
  hoveredProcessId,
  setHoveredProcessId,
  setOpenSocketId,
  onSocketFinalized,
  openSocketId,
  onRtProcessAndSocketsAdd,
  onRtSocketsAdd
}) => {
  // get all input OR output sockets depending on "output" prop
  const dtSocketsIO = dtSockets.filter(dtSock => output ? dtSock.io === 'output' : dtSock.io === 'input');
  // console.log(output, dtSockets, dtSocketsIO)



  // get all process ids mentioned in sockets
  const processIdsLinkedToSocket = dtSocketsIO.map(dtSock => dtSock.process);

  // initialize an empty array to hold all ancestors
  let allAncestors = [];

  // loop through them and get the ancestors of each of them
  processIdsLinkedToSocket.forEach(processId => {
    const ancestors = getAncestorProcesses(processId, dtProcesses);
    allAncestors = [...allAncestors, ...ancestors];
  });

  return (
    <div className={c["ctr"]}>
      <div className={`${c["header"]} ${output ? c["left"] : ""} ${c['ctr-inner-padding']}`}>
        {output ? "Output" : "Input"}
      </div>
      <div className={`${c["body"]} ${c['ctr-inner-padding']}`}>
        <Process
          rtTaskId={rtTaskId} 
          output={output}
          rtProcess={null}
          dtProcess={null}
          descendantRtProcesses={rtProcesses}
          descendantDtProcesses={dtProcesses}
          dtSockets={dtSockets}
          rtSockets={rtSockets}
          onSocketFinalized={onSocketFinalized}
          hoveredProcessId={hoveredProcessId}
          setHoveredProcessId={setHoveredProcessId}

          openSocketId={openSocketId}
          setOpenSocketId={setOpenSocketId}

          onRtProcessAndSocketsAdd={onRtProcessAndSocketsAdd}
          onRtSocketsAdd={onRtSocketsAdd}
        />
      </div>
    </div>
  )
}